import React from "react";
import "./AboutHoldingSection.css";

const items = [
  {
    "src": './img/partners/erth.png',
    "href": ""
  },
  {
    "src": './img/partners/dom.png',
    "href": 'https://hh.ru/employer/10492215?hhtmFrom=employers_list'
  },
  {
    "src": './img/partners/dombis.png',
    "href": ""
  },
  {
    "src": './img/partners/rone.png',
    "href": ""
  },
  {
    "src": './img/partners/rx.png',
    "href": ""
  },
  {
    "src": './img/partners/akado.png',
    "href": 'https://hh.ru/employer/13820?hhtmFrom=employers_list'
  },
  {
    "src": './img/partners/movix.png',
    "href": ""
  },
  {
    "src": './img/partners/itps.png',
    "href": 'https://hh.ru/employer/40791?hhtmFrom=employers_list'
  },
  {
    "src": './img/partners/Larctech.png',
    "href": 'https://hh.ru/employer/2107696?hhtmFrom=employers_list'
  },
  {
    "src": './img/partners/linx.png',
    "href": ""
  },
  {
    "src": './img/partners/digitalrservice.png',
    "href": 'https://hh.ru/employer/39601?hhtmFrom=employers_list'
  },
  {
    "src": './img/partners/avantel.png',
    "href": ""
  },
  {
    "src": './img/partners/ihome.png',
    "href": ""
  },
  {
    "src": './img/partners/electrocity.png',
    "href": 'https://hh.ru/employer/69797?hhtmFrom=employers_list'
  },
  {
    "src": './img/partners/delset.png',
    "href": ""
  },
  {
    "src": './img/partners/napa.png',
    "href": ""
  }
]

function AboutHoldingSection() {
  return (
    <div className="AboutHoldingSection">
      <h2 lang="ru" className="AboutHoldingSection-title">
        ЭР-ТЕЛЕКОМ ХОЛДИНГ — ЭТО КОМАНДА ЭФФЕКТИВНОГО РАЗВИТИЯ ТЕЛЕКОМА
      </h2>
      <div className="AboutHoldingIMG">
        <img className="icon" src={require('./img/partners/erth.png')}/>
        <a href="https://hh.ru/employer/10492215?hhtmFrom=employers_list">
          <img className="icon" src={require('./img/partners/dom.png')}/>
        </a>
        <img className="icon" src={require('./img/partners/dombis.png')}/>
        <img className="icon" src={require('./img/partners/rone.png')}/>
        <img className="icon" src={require('./img/partners/rx.png')}/>
        <a href="https://hh.ru/employer/13820?hhtmFrom=employers_list">
          <img className="icon" src={require('./img/partners/akado.png')}/>
        </a>
        <img className="icon" src={require('./img/partners/movix.png')}/>
        <a href="https://hh.ru/employer/40791?hhtmFrom=employers_list">
          <img className="icon" src={require('./img/partners/itps.png')}/>
        </a>
        <a href="https://hh.ru/employer/2107696?hhtmFrom=employers_list">
          <img className="icon" src={require('./img/partners/Larctech.png')}/>
        </a>
        <img className="icon" src={require('./img/partners/linx.png')}/>
        <a href="https://hh.ru/employer/39601?hhtmFrom=employers_list">
          <img className="icon" src={require('./img/partners/digitalrservice.png')}/>
        </a>
        <img className="icon" src={require('./img/partners/avantel.png')}/>
        <img className="icon" src={require('./img/partners/ihome.png')}/>
        <a href="https://hh.ru/employer/69797?hhtmFrom=employers_list">
          <img className="icon" src={require('./img/partners/electrocity.png')}/>
        </a>
        <img className="icon" src={require('./img/partners/delset.png')}/>
        <img className="icon" src={require('./img/partners/napa.png')}/>
      </div>
      <div className="Advantages">
        <div className="Advantage">
          <p className="AdvantageTitle">с 2001</p>
          <p className="AdvantageDescription">года на рынке телекоммуникаций</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">№5</p>
          <p className="AdvantageDescription">телеком-компания в России</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">2/3</p>
          <p className="AdvantageDescription">охват России</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">15,1</p>
          <p className="AdvantageDescription">млн. домохозяйств в сети</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">9000+</p>
          <p className="AdvantageDescription">сотрудников</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">97 000+</p>
          <p className="AdvantageDescription">км. магистральной сети</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">52</p>
          <p className="AdvantageDescription">города крупнейшая IoT сеть LoRaWAN</p>
        </div>
        <div className="Advantage">
          <p className="AdvantageTitle">105 000+</p>
          <p className="AdvantageDescription">км. протяженность оптоволоконной сети</p>
        </div>
      </div>
      <span>
        ЭР-Телеком Холдинг — частная российская цифровая инфраструктурная компания
      </span>
    </div>
  );
}

export default AboutHoldingSection;



// WEBPACK FOOTER //
// ./src/components/AboutHoldingSection/index.js